//import DashboardLayout from "../pages/Layout/DashboardLayout.vue";
// Clients pages
import ClientsList from "../pages/Clients/List.vue";
import ClientView from "../pages/Clients/View.vue";
// Dashboard pages
import Dashboard from "../pages/Dashboard.vue";
//Data Validation
import LoginLayout from "../pages/Layouts/LoginLayout.vue";
import MiddlewareLayout from "../pages/Layouts/MiddlewareLayout.vue";
import XperienceLayout from "../pages/Layouts/XperienceLayout.vue";
import OptionsCurrencies from "../pages/Options/Currencies/View.vue";
import OptionsCurrencyRate from "../pages/Options/CurrencyRate/List.vue";
import OptionsFees from "../pages/Options/Fees/View.vue";
import OptionsFittingTypes from "../pages/Options/FittingTypes/View.vue";
import OptionsIronTypes from "../pages/Options/IronTypes/View.vue";
// Options pages
import OptionsLocations from "../pages/Options/Locations/View.vue";
import OptionsShops from "../pages/Options/Shops/View.vue";
import OptionsUsers from "../pages/Options/Users/View.vue";
// Orders
import OrderList from "../pages/Orders/List.vue";
import OrderPrint from "../pages/Orders/Print.vue";
import OrderView from "../pages/Orders/View.vue";
import Login from "../pages/Pages/Login.vue";
// Prescription pages
import PrescriptionList from "../pages/Prescription/List.vue";
import PrescriptionPrint from "../pages/Prescription/Print.vue";
import PrescriptionQuote from "../pages/Prescription/Quote.vue";
import PrescriptionView from "../pages/Prescription/View.vue";
import Catalogs from "../pages/Products/Catalogs.vue";
// Products pages
import ProductsList from "../pages/Products/List.vue";
import ProductView from "../pages/Products/View.vue";
//PO's
import PurchaseOrderList from "../pages/PurchaseOrders/List.vue";
import PurchaseOrderView from "../pages/PurchaseOrders/View.vue";
import BuildBuild from "../pages/Build/View.vue";
//Sales
import BuildList from "../pages/Build/List.vue";
import BuildPackageList from "../pages/Build/PrintPackageList.vue";
//Scheduler
import SchedulerView from "../pages/Scheduler/View.vue";
import SetList from "../pages/Sets/Sets.vue";
// Sets
import SetView from "../pages/Sets/View.vue";
import SimulatorClient from "../pages/Simulators/ClientList.vue";
// Simulator
import SimulatorDashboard from "../pages/Simulators/Dashboard.vue";
import SimulatorOptions from "../pages/Simulators/Options.vue";
import SimulatorSimulators from "../pages/Simulators/Simulators.vue";
import SimulatorPos from "../pages/Simulators/Pos.vue";

import ReportIndex from "../pages/Report/Index.vue"
import {AccountFeatures} from "@/utils/enum";
import {REACT_URL} from "@/common/config-local";



const FITTER_LEVEL = 6;
const BUILDER_LEVEL = 3;
const CLIENT_LEVEL = 0;
const ADMIN_LEVEL = 9;

let productsMenu = {
  path: "/products",
  component: MiddlewareLayout,
  redirect: "/products/list",
  name: "Product",
  meta: {
    feature: AccountFeatures.ORDER,
    requiresAuth: true,
    accessLevel: BUILDER_LEVEL
  },
  children: [
    {
      path: "list",
      name: "Product List",
      components: { default: ProductsList },
      meta: {
        requiresAuth: true,
        accessLevel: BUILDER_LEVEL
      }
    },
    {
      path: "catalog",
      name: "Catalogs",
      components: { default: Catalogs },
      meta: {
        requiresAuth: true,
        accessLevel: BUILDER_LEVEL
      }
    },
    {
      path: "catalog/:id",
      name: "Catalog Products",
      components: { default: () => import("../pages/Products/CatalogProducts.vue") },
      meta: {
        requiresAuth: true,
        accessLevel: BUILDER_LEVEL
      }
    },
    {
      path: "view/:id",
      name: "Product View",
      components: { default: ProductView },
      redirect: to => {
        const productId = to.params.id
        window.location.href = `${REACT_URL}/products/${productId}`
      },
      meta: {
        requiresAuth: true,
        accessLevel: BUILDER_LEVEL
      }
    },
    {
      path: "label/:id",
      name: "Product Label",
      components: { default: () => import("../pages/Products/Label.vue") },
      meta: {
        requiresAuth: true,
        accessLevel: BUILDER_LEVEL
      }
    }
  ]
};

let BuildMenu = {
  path: "/build",
  component: MiddlewareLayout,
  redirect: "/build/list",
  name: "Build",
  meta: {
    feature: AccountFeatures.WAREHOUSE,
    requiresAuth: true,
    accessLevel: BUILDER_LEVEL
  },
  children: [
    {
      path: "list",
      name: "Build List",
      components: { default: BuildList },
      meta: {
        requiresAuth: true,
        accessLevel: BUILDER_LEVEL
      }
    },
    {
      path: "build/:id",
      name: "Build Order",
      components: { default: BuildBuild },
      meta: {
        requiresAuth: true,
        accessLevel: BUILDER_LEVEL
      }
    },
    {
      path: "build/:id/package-list",
      name: "Package List",
      components: { default: BuildPackageList},
      meta: {
        requiresAuth: true,
        accessLevel: BUILDER_LEVEL
      }
    },
    {
      path: "cart",
      name: "Cart",
      components: { default: () => import("../pages/Build/Cart.vue") },
      meta: {
        requiresAuth: true,
        accessLevel: BUILDER_LEVEL
      }
    },
    {
      path: "handling/list",
      name: "Handling List",
      components: { default: () => import("../pages/Build/Handling/List.vue") },
      meta: {
        requiresAuth: true,
        accessLevel: BUILDER_LEVEL
      }
    },
    {
      // La page de montage vit désormais côté React (doma-golf-middleware-react,
      // src/app/(middleware)/build/handling/[id]). On garde l'URL historique :
      // c'est celle que l'équipe de montage a en favori et que le back renvoie
      // dans ses liens.
      path: "handling/:id",
      name: "Handling Detail",
      components: { default: () => import("../pages/Build/Handling/View.vue") },
      redirect: to => {
        const handlingId = to.params.id
        window.location.href = `${REACT_URL}/build/handling/${handlingId}`
      },
      meta: {
        requiresAuth: true,
        accessLevel: BUILDER_LEVEL
      }
    }

  ]
};

let setsMenu = {
  path: "/sets",
  component: MiddlewareLayout,
  redirect: "/sets/list",
  name: "Sets",
  meta: {
    feature: AccountFeatures.ORDER,
    requiresAuth: true,
    accessLevel: BUILDER_LEVEL
  },
  children: [
    {
      path: "list",
      name: "Set List",
      components: { default: SetList },
      meta: {
        requiresAuth: true,
        accessLevel: BUILDER_LEVEL
      }
    },
    {
      path: "view/:id",
      name: "Set View",
      components: { default: SetView },
      meta: {
        requiresAuth: true,
        accessLevel: BUILDER_LEVEL
      }
    }
  ]
};

let ordersMenu = {
  path: "/orders",
  component: MiddlewareLayout,
  redirect: "/orders/list",
  name: "Orders",
  meta: {
    feature: AccountFeatures.ORDER,
    requiresAuth: true,
    accessLevel: FITTER_LEVEL
  },
  children: [
    {
      path: "list",
      name: "Orders List",
      components: { default: OrderList },
      beforeEnter: () => {
        window.location.href = `${REACT_URL}/orders`
      },
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },
    {
      path: "view/:id",
      name: "Order view",
      components: { default: OrderView },
      beforeEnter: (to) => {
        const orderId = to.params.id
        window.location.href = `${REACT_URL}/orders/${orderId}`
      },
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },
    {
      path: "print/:id/:type",
      name: "Print Order",
      components: { default: OrderPrint },
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    }
  ]
};

let invoicesMenu = {
  path: "/invoices",
  component: MiddlewareLayout,
  redirect: "/invoices/list",
  name: "Invoices",
  meta: {
    feature: AccountFeatures.INVOICE,
    requiresAuth: true,
    accessLevel: FITTER_LEVEL
  },
  children: [
    {
      path: "list",
      name: "Invoice List",
      components:{
        default : () => import('../pages/Invoices/List.vue')
      } ,
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },{
      path: "payout",
      name: "Payout List",
      components:{
        default : () => import('../pages/Payouts/List.vue')
      } ,
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },
  ]
};


let optionsMenu = {
  path: "/options",
  component: MiddlewareLayout,
  redirect: "/options/lists",
  name: "Options",
  meta: {
    requiresAuth: true,
    accessLevel: FITTER_LEVEL
  },
  children: [
    {
      path: "shops",
      name: "Options > Shops",
      components: { default: OptionsShops },
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },
    {
      path: "currencies",
      name: "Options > Currencies",
      components: { default: OptionsCurrencies },
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },
    {
      path: "currency-rates",
      name: "Options > Currency Rates",
      components: { default: OptionsCurrencyRate },
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },
    {
      path: "locations",
      name: "Options > Locations",
      components: { default: OptionsLocations },
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },
    {
      path: "fitting-types",
      name: "Options > Fitting Types",
      components: { default: OptionsFittingTypes },
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },
    {
      path: "fees",
      name: "Options > Fees",
      components: { default: OptionsFees },
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },
    {
      path: "iron-types",
      name: "Options > Iron Types",
      components: { default: OptionsIronTypes },
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },
    {
      path: "users",
      name: "Options > Users",
      components: { default: OptionsUsers },
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },
    {
      path: "tax-rates",
      name: "Tax Rate",
      components: { default: () => import("../pages/Options/TaxRates/List") },
      meta: {
        requiresAuth: true,
        accessLevel: ADMIN_LEVEL
      }
    },
  ]
};

let clientsMenu = {
  path: "/clients",
  component: MiddlewareLayout,
  redirect: "/clients/dashboard",
  name: "Clients",
  meta: {
    feature: AccountFeatures.ORDER,
    requiresAuth: true,
    accessLevel: FITTER_LEVEL
  },
  children: [
    {
      path: "list",
      name: "Clients List",
      components: { default: ClientsList },
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },
    {
      path: "view/:id",
      name: "Client detail",
      components: { default: ClientView },
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    }
  ]
};

let prescriptionMenu = {
  path: "/prescription",
  component: MiddlewareLayout,
  redirect: "/prescription/list",
  name: "Prescription",
  meta: {
    feature: AccountFeatures.PRESCRIPTION,
    requiresAuth: true,
    accessLevel: CLIENT_LEVEL
  },
  children: [
    {
      path: "list",
      name: "Prescription List",
      components: { default: PrescriptionList },
      meta: {
        requiresAuth: true,
        accessLevel: CLIENT_LEVEL
      }
    },
    {
      path: "view/:id",
      name: "Prescription New",
      components: { default: PrescriptionView },
      meta: {
        requiresAuth: true,
        accessLevel: CLIENT_LEVEL
      }
    },
    {
      path: "print/:id",
      name: "Prescription Print",
      components: { default: PrescriptionPrint },
      meta: {
        requiresAuth: true,
        accessLevel: CLIENT_LEVEL
      }
    },
    {
      path: "quote/:id",
      name: "Prescription Quote",
      components: { default: PrescriptionQuote },
      meta: {
        requiresAuth: true,
        accessLevel: CLIENT_LEVEL
      }
    }
  ]
};

let inventoryPages = {
  path: "/inventory",
  component: MiddlewareLayout,
  name: "Inventory",
  meta:{
    feature: AccountFeatures.WAREHOUSE,
  },
  children: [
    {
      path: "warehouse",
      name: "Warehouse",
      components:{
        default : () => import('../pages/Inventory/Warehouse.vue')
      } 
    },
    {
      path: "warehouse/:id",
      name: "Warehouse Location",
      components:{
        default : () => import('../pages/Inventory/WarehouseLocation.vue')
      } 
    },
    {
      path: "suppliers",
      name: "Suppliers",
      components:{
        default : () => import('../pages/Inventory/SupplierList.vue')
      } 
    },
    {
      path: "suppliers/:id",
      name: "Supplier Detail",
      components:{
        default : () => import('../pages/Inventory/SupplierDetail.vue')
      } 
    }
  ]
};

let pickwavePages = {
  path: "/pickwave",
  component: MiddlewareLayout,
  redirect: "/pickwave/list",
  name: "Pick Wave",
  meta: {
    feature: AccountFeatures.ORDER,
  },
  children: [
    {
      path: "list",
      name: "Pick Waves",
      components:{
        default : () => import('../pages/PickWave/List.vue')
      } 
    },
    {
      path: ":id",
      name: "Pick Wave Detail",
      components:{
        default : () => import('../pages/PickWave/View.vue')
      } 
    },
  ]
};

let authPages = {
  path: "/auth",
  component: LoginLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/forgot-password",
      name: "Login",
      component: () => import('../pages/Pages/ForgotPassword.vue')
    },
    {
      path: "/reset-password",
      name: "Reset Password",
      component: () => import('../pages/Pages/ResetPassword.vue')
    }
  ]
};

let purchaseOrderPages = {
  path: "/purchase-order",
  component: MiddlewareLayout,
  redirect: "/purchase-order/list",
  name: "Purchase Orders",
  meta: {
    feature: AccountFeatures.WAREHOUSE,
    requiresAuth: true,
    accessLevel: CLIENT_LEVEL
  },
  children: [
    {
      path: "List",
      name: "List",
      component: PurchaseOrderList,
      meta: {
        requiresAuth: true,
        accessLevel: CLIENT_LEVEL
      }
    },
    {
      path: "create",
      name: "Create",
      components: { default: () => import("../pages/PurchaseOrders/Form.vue") },
      meta: {
        requiresAuth: true,
        accessLevel: CLIENT_LEVEL
      }
    },
    {
      path: "update/:id",
      name: "Update",
      components: { default: () => import("../pages/PurchaseOrders/Form.vue") },
      meta: {
        requiresAuth: true,
        accessLevel: CLIENT_LEVEL
      }
    },
    {
      path: "view/:id",
      name: "Purchase Orders Detail",
      components: { default: PurchaseOrderView },
      meta: {
        requiresAuth: true,
        accessLevel: CLIENT_LEVEL
      }
    },
  ]
};

let purchaseOrderSkuVaultPages = {
  path: "/purchase-order-skuvault",
  component: MiddlewareLayout,
  redirect: "/purchase-order-skuvault/list",
  name: "Purchase Orders (skuvault)",
  meta: {
    feature: AccountFeatures.WAREHOUSE,
    requiresAuth: true,
    accessLevel: CLIENT_LEVEL
  },
  children: [
    {
      path: "List",
      name: "PO Sku List",
      components: { default: () => import("../pages/PurchaseOrdersSkuVault/List.vue") },
      meta: {
        requiresAuth: true,
        accessLevel: CLIENT_LEVEL
      }
    },
    {
      path: "create",
      name: "PO Sku Create",
      components: { default: () => import("../pages/PurchaseOrdersSkuVault/Create.vue") },
      meta: {
        requiresAuth: true,
        accessLevel: CLIENT_LEVEL
      }
    },
    {
      path: "view/:id",
      name: "PO Sku Detail",
      components: { default: () => import("../pages/PurchaseOrdersSkuVault/View.vue") },
      meta: {
        requiresAuth: true,
        accessLevel: CLIENT_LEVEL
      }
    },
  ]
};



let helpPages = {
  path: "/help",
  component: MiddlewareLayout,
  redirect: "/help/index",
  name: "Help",
  meta: {
    feature: AccountFeatures.ORDER,
    requiresAuth: true,
    accessLevel: CLIENT_LEVEL
  },
  children: [
    {
      path: "index",
      name: "Index",
      components: { default: () => import("../pages/Static/Help/Index.vue") },
      meta: {
        requiresAuth: true,
        accessLevel: CLIENT_LEVEL
      }
    },
    {
      path: "prescriptions",
      name: "Aide Prescriptions",
      components: { default: () => import("../pages/Static/Help/Prescriptions.vue") },
      meta: {
        requiresAuth: true,
        accessLevel: CLIENT_LEVEL
      }
    },
    {
      path: "orders",
      name: "Aide Commandes",
      components: { default: () => import("../pages/Static/Help/Orders.vue") },
      meta: {
        requiresAuth: true,
        accessLevel: CLIENT_LEVEL
      }
    },
    {
      path: "builds",
      name: "Aide Builds",
      components: { default: () => import("../pages/Static/Help/Builds.vue") },
      meta: {
        requiresAuth: true,
        accessLevel: CLIENT_LEVEL
      }
    },
    {
      path: "invoices",
      name: "Aide Facturation",
      components: { default: () => import("../pages/Static/Help/Invoices.vue") },
      meta: {
        requiresAuth: true,
        accessLevel: CLIENT_LEVEL
      }
    },
    {
      path: "inventory",
      name: "Aide Inventory",
      components: { default: () => import("../pages/Static/Help/Inventory.vue") },
      meta: {
        requiresAuth: true,
        accessLevel: CLIENT_LEVEL
      }
    },
    
  ]
};

let bexioPages = {
  path: "/bexio",
  component: MiddlewareLayout,
  redirect: "/bexio/dashboard",
  name: "Bexio",
  meta: {
    feature: AccountFeatures.BEXIO,
    requiresAuth: true,
    accessLevel: FITTER_LEVEL
  },
  children: [
    {
      path: "dashboard",
      name: "Bexio Dashboard",
      components: { default: () => import("../pages/Bexio/Dashboard.vue") },
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },{
      path: "account",
      name: "Accounts",
      components: { default: () => import("../pages/Bexio/Account.vue") },
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },{
      path: "actions",
      name: "Actions",
      components: { default: () => import("../pages/Bexio/Actions.vue") },
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    }
  ]
};


let simulatorMenu = {
  path: "/simulator",
  component: XperienceLayout,
  redirect: "/simulator/dashboard",
  name: "Simulator",
  meta: {
    feature: AccountFeatures.XPERIENCE,
    requiresAuth: true,
    accessLevel: FITTER_LEVEL
  },
  children: [
    {
      path: "dashboard",
      name: "Simulator Dashboard",
      components:{default: SimulatorDashboard},
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },
    {
      path: "planning",
      name: "Scheduler detail",
      components: { default: SchedulerView },
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },
    {
      path: "options",
      name: "Simulator Options",
      components:{default: SimulatorOptions},
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },
    {
      path: "simulators",
      name: "Simulator Simulators",
      components:{default: SimulatorSimulators},
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },

    {
      path: "pos",
      name: "Simulator POS",
      components:{default: SimulatorPos},
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },
    
    {
      path: "clients",
      name: "Simulator Client",
      components:{default: SimulatorClient},
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },
  ]
};


let reportMenu = {
  path: "/report",
  component: MiddlewareLayout,
  redirect: "/report/index",
  name: "Reporting",
  meta: {
    feature: AccountFeatures.REPORTING,
    requiresAuth: true,
    accessLevel: FITTER_LEVEL
  },
  children: [
    {
      path: "index",
      name: "Reporting Index",
      components:{default: ReportIndex},
      meta: {
        requiresAuth: true,
        accessLevel: FITTER_LEVEL
      }
    },
    {
      path: "sales-by-fitter",
      name: "Sales by fitter",
      components:{
        default: () => import("../pages/Report/SalesByFitter.vue")
      },
      meta: {
        requiresAuth: true,
        accessLevel: ADMIN_LEVEL
      }
    },
    {
      path: "credit-by-user",
      name: "Xperience's Credits",
      components:{
        default: () => import("../pages/Report/CreditByUser.vue")
      },
      meta: {
        requiresAuth: true,
        accessLevel: ADMIN_LEVEL
      }
    },
  ]
};

let notificationPages = {
  path: "/notifications",
  component: MiddlewareLayout,
  redirect: "/notifications/index",
  name: "Notifications",
  meta: {
    requiresAuth: true,
    accessLevel: ADMIN_LEVEL
  },
  children: [
    {
      path: "index",
      name: "Notifications Index",
      components: { default: () => import("../pages/Notifications/Index.vue") },
      meta: {
        requiresAuth: true,
        accessLevel: ADMIN_LEVEL
      }
    },
    {
      path: "config",
      name: "Notifications Config",
      components: { default: () => import("../pages/Notifications/Config.vue") },
      meta: {
        requiresAuth: true,
        accessLevel: ADMIN_LEVEL
      }
    },
  ]
}

// La page d'accueil est le dashboard de l'app React (/v2) : changement
// d'app, donc navigation complète. requiresAuth envoie d'abord un visiteur
// non connecté sur /login.
const homeRedirect = {
  path: "/home",
  name: "Home Redirect",
  beforeEnter: () => {
    window.location.href = `${REACT_URL}/dashboard`
  },
  meta: {
    requiresAuth: true
  }
};

const routes = [
  {
    path: "/",
    component: MiddlewareLayout,
    redirect: "/home",
    name: "Home",

    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        components: { default: Dashboard },
        meta: {
          requiresAuth: true,
          accessLevel: CLIENT_LEVEL
        }
      }
    ]
  },
  homeRedirect,
  ordersMenu,
  invoicesMenu,
  productsMenu,
  setsMenu,
  clientsMenu,
  prescriptionMenu,
  authPages,
  optionsMenu,
  BuildMenu,
  helpPages,
  purchaseOrderPages,
  purchaseOrderSkuVaultPages,
  simulatorMenu,
  reportMenu,
  inventoryPages,
  pickwavePages,
  notificationPages,
  bexioPages
];

export default routes;
